'use strict';exports.__esModule = true;var eventCategory = exports.eventCategory = {
  propertyDetails: 'Property Details',
  newAccount: 'New Account',
  publish: 'Publish',
  contactUs: 'Contact Us',
  homePage: 'Home Page',
  searchResults: 'Search Results',
  favorites: 'Favorites',
  error: 'Error',
  notes: 'Notes',
  share: 'Share',
  property: 'Property',
  login: 'Login',
  headerNavigation: 'Header Navigation',
  newProject: 'newProject',
  publishedProperty: 'published_property',
  contactViews: 'contact_views',
  contactViewsSale: 'contact_views_sale',
  contactViewsRent: 'contact_views_rent',
  startNewProject: 'start_newProject',
  purchase: 'purchase' };


var eventAction = exports.eventAction = {
  click: 'click',
  show: 'show',
  publish: 'publish',
  create: 'create',
  open: 'open',
  close: 'close',
  change: 'change',
  add: 'add',
  remove: 'remove',
  login: 'login',
  register: 'register',
  search: 'search',
  validation: 'phone validation',
  moveToTop: 'move to top',
  tempToRegular: 'temp to regular',
  success: 'success' };


var eventLabel = exports.eventLabel = {
  email: 'Email',
  phoneNumber: 'Phone Number',
  contactDetails: 'Contact details',
  publish: 'Publish',
  contactUs: 'Contact Us',
  scrollDown: 'Scroll Down',
  projectsSection: 'Projects Section',
  filter: 'Filter',
  list: 'List',
  favorites: 'Favorites',
  advancedFilter: 'Advanced Filter',
  search: 'Search',
  drawOnMap: 'Draw On Map',
  optionType: 'Option Type',
  searchPage: 'Search Page',
  propertyDetailsModal: 'Property Details Modal',
  propertyDetailsPage: 'Property Details Page',
  searchResultsPage: 'Search Results Page',
  managePropertiesPage: 'Manage Properties Page',
  notValidAddress: 'Address not valid',
  moveToTop: 'Move to top',
  secondMoveToTop: 'Second Move to top',
  openMortgageCalculator: 'Open mortgage calculator',
  agentPublish: 'By Agent',
  userPublish: 'By User',
  additionalFilters: 'Additional filters',
  publishBanner: 'Publish banner',
  applications: 'Applications',
  recentSearches: 'Recent searches',
  newPropertiesForSale: 'New properties for sale',
  propertiesForSaleIn: 'More properties for sale in',
  newPropertiesForRent: 'New properties for rent',
  propertiesForRentIn: 'More properties for rent in',
  newHomes: 'New homes',
  propertiesUnderMillion: 'Properties under million',
  propertiesByTypes: 'Properties by type',
  propertyType: 'Property type',
  professionals: 'Professionals',
  professionalsJoin: 'Join professionals',
  propertiesForSaleUnder: 'Properties for sale under',
  propertiesForSaleByRooms: 'Properties for sale by rooms',
  forSale: 'For sale',
  forRent: 'For rent',
  commercial: 'Commercial',
  projects: 'New homes',
  help: 'Help',
  articles: 'Articles',
  virtualTour: 'Virtual tour',
  login: 'Login',
  newAccount: 'New account',
  language: 'Language',
  manageProperties: 'Manage properties',
  editProfile: 'Edit profile',
  savedSearches: 'Saved searches',
  about: 'About us' };


//////////////////
// WEBPACK FOOTER
// ./src/utils/analytics/analyticsConstants.js
// module id = 36
// module chunks = 0